shadow$provide[184] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Classes:{enumerable:true, get:function() {
  return Classes;
}}});
var require$_DOT__SLASH_dom_DOT_js = require("./dom.js");
const Classes = {dom:require$_DOT__SLASH_dom_DOT_js.DOM};

};